import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiPortraitGeneratorConfig } from '@/data/landingConfig/landingAiPortraitGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiPortraitGenerator } from './schemaObject';

interface Props {}
const AiPortraitGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiPortraitGenerator} />
			<LandingTemplate
				data={landingAiPortraitGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelHeadshotGenerator()}
			/>
		</>
	);
};

export default AiPortraitGenerator;
